export const badgeLocations = {
  trophy: require('../assets/svg/trophy.svg'),
  pencil: require('../assets/svg/pencil.svg'),
}